import * as yup from 'yup'

import { LocaleJP } from './LocaleJP'

export { yupResolver } from '@hookform/resolvers/yup'

// yup に作った日本語メッセージを定義
yup.setLocale(LocaleJP)

// yup は import する度に setLocale する必要があるので setLocale 済みの yup を呼び出せるように export

export * as yup from 'yup'
export * as BaseYup from 'yup'
